import { createContextTools } from "@orgiggly/shared";
import { useCallback, useState } from "react";

export type SnackbarMessage = {
  message: string;
  severity: "success" | "error" | "warning" | "info";
  /** Optional call to action rendered as a link button beside the message. */
  link?: { label: string; href: string };
};

export type SnackbarContext = {
  message: SnackbarMessage | undefined;
  isOpen: boolean;
  openSnackbar: (message: SnackbarMessage) => void;
  closeSnackbar: () => void;
};

export const [SnackbarProvider, useSnackbar] =
  createContextTools<SnackbarContext>("snackbar");

export const useCreateSnackbar = (): SnackbarContext => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState<SnackbarMessage | undefined>(
    undefined,
  );

  const openSnackbar = useCallback((message: SnackbarMessage) => {
    setMessage(message);
    setIsOpen(true);
  }, []);

  const closeSnackbar = useCallback(() => {
    setIsOpen(false);
  }, []);
  return { message, openSnackbar, closeSnackbar, isOpen };
};

export const useOpenSnackbar = () => {
  const { openSnackbar } = useSnackbar();
  return openSnackbar;
};
